jQuery(document).foundation();
var $ = jQuery;


$(document).ready(function () {
  $('#menu-item-73 a').on('click', function () {
    $('#off-canvas').foundation('close');
  });

  $('.grid').masonry({
    // options
    itemSelector: '.blogbeitrag',
    columnWidth: '.blogbeitrag',
    percentPosition: true
  });

  var slidehidden = false;
  var firstslide = "";

  $('#offcanvas-nav').foundation('showAll');

  $('#news-slider').not('.slick-initialized').slick({
    slidesToShow: 1,
    accessibility: false,
    mobileFirst: true,
    autoplay: false,
    autoplaySpeed: 5000,
    dots: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: false,
          infinite: false,
          autoplay: false,
          slidesToShow: 1,
          variableWidth: true,
          adaptiveHeight: false,
        }
      },
    ]
  });

  if (!Foundation.MediaQuery.is('medium') && !slidehidden) {
    firstslide = $("#news-slider .aktuelles-intro").parent().html();
    $('#news-slider').slick('slickRemove', 0);
    slidehidden = true;
  }
  
  $(window).resize(function () {
    if (!Foundation.MediaQuery.is('medium') && !slidehidden) {
      firstslide = $("#news-slider .aktuelles-intro").parent().html();
      $('#news-slider').slick('slickRemove', 0);
      slidehidden = true;
    }
    else if (Foundation.MediaQuery.is('medium') && slidehidden) {
      $('#news-slider').slick('slickAdd', '<div><h3>' + firstslide + '</h3></div>', true);
      slidehidden = false;
    }
  });


  if ($(this).scrollTop() < 250) {
    var opacity = 1 - ($(this).scrollTop()) / 250;
    $(".top-bar").css({ "background-color": "rgba(255, 255, 255," + opacity + ")" })
  } else {
    $(".top-bar").css({ "background-color": "rgba(255, 255, 255, 0)" })
  }
  $(window).scroll(function () {

    if ($(this).scrollTop() < 250) {
      var opacity = 1 - ($(this).scrollTop()) / 250;
      $(".top-bar").css({ "background-color": "rgba(255, 255, 255," + opacity + ")" })
    } else {
      $(".top-bar").css({ "background-color": "rgba(255, 255, 255, 0)" })
    }
  })


  // Kalender Filter Checkboxen
  $('.filter-tax').on("click", "li", function (e) {
    var filter = $(this).find("[type=checkbox]");

    var check_prop = false;

    if (!filter.prop("checked")) {
      check_prop = true;
    }
    else {
      check_prop = false;
    }

    // set Checkboxes of Filter Category
    $(filter).parent().find("[type=checkbox]").each(function () {
      $(this).prop('checked', check_prop);
    });

    if (!filter.prop("checked")) {
      $(".checkbox-" + filter.attr("id")).prop('checked', false);
    } else {
      $(".checkbox-" + filter.attr("id")).prop('checked', true);
    }




    updateFilter();
    updateCalendar();


    e.stopPropagation();
    e.preventDefault();


  });

  function updateFilter() {
    let filterused = false;
    $('.filter-tax').find("[type=checkbox]").each(function () {
      if (!$(this).prop("checked")) {
        filterused = true;
      }
    });

    $(".kalender-list .accordion-item").each(function () {
      $(this).removeClass('visbyfilter');

      let active = true;

      let categoryvisible = false;

      let categoryavailable = false;

      $($(this).attr('class').split(/\s+/)).each(function () {
        var class_item = this; //jede Klasse einmal anschauen
        if (
          class_item != "accordion-item" &&
          class_item != "visbydate" &&
          class_item != "visbyfilter" &&
          class_item != "visbydefault" &&
          class_item != "is-active" &&
          class_item != "normal" &&
          class_item.substring(0, 4) != "date") {

          active = false;

          

          $(".filter-tax").find("#" + class_item).each(function () {

            categoryavailable = true;
            if ($(this).prop('checked')) {
              categoryvisible = true;

            }
          });


        }

      });
      if (categoryvisible) { //
        active = true;
      }
      if (active) {
        $(this).addClass('visbyfilter');
      }
      if (!filterused) {
        $(this).addClass('visbyfilter');
      }
    });

  }
  // Kalender Datum Filter
  $('.calendar-selection .day > a').click(function (e) {
    e.preventDefault();
    var params = {};
    var dateused = true;
    if ($(this).parent(".day").hasClass("cur")) {
      dateused = false;
      $(".kalender-list .accordion-item").each(function () {
        $(this).removeClass('visbydate');
        if($(this).hasClass('visiblebydefault')){
          $(this).addClass('visbydate');
        }

          
      
        $(".day").removeClass("cur");

        updateFilter();
        updateCalendar();


      });
    }
    else if ($(this).parent(".day").hasClass("active")) { //funktioniert nicht bei aktivem Filter für Veranstaltungen mit zwei Kategorien
      // cur Klasse wecheln
      $(".day").removeClass("cur");
      $(this).parent(".day").addClass("cur");
      var id = $(this).parent(".day").attr("id");
      var datestring = $(this).parent(".day").attr("datestring");


      // Scroll To Event
      var target = $('.kalender-list .' + id);

      // alten Tag ausblenden
      $(".kalender-list .accordion-item").removeClass('visbydate');

      // neuen Tag einblenden
      $(".kalender-list .accordion-item[class*=" + id).each(function () {
        $(this).addClass('visbydate');


      });

      // Datum übergeben
      params["date"] = $(".day.cur").attr("id");
    }
    if (!dateused) {
      $(".kalender-list .accordion-item.visbydefault").each(function () {
        $(this).addClass('visbydate');
      });
    }

  });
  function updateCalendar() {
    $(".calendar-selection .day.active").each(function () {

      date = $(this).attr('id');
      $(this).removeClass('activebutfiltered');

      activebutfiltered = true;
      if ($(this).hasClass("cur")) {
        $(this).removeClass("cur");
      }

      $("." + date).each(function () {
        if ($(this).hasClass("visbyfilter")) {
          activebutfiltered = false;
        }
      });

      if (activebutfiltered) {
        $(this).addClass('activebutfiltered');
      }
    });
  }



})
jQuery(document).ready(function($) {
    // Variable zum Speichern des ursprünglichen Links
    var targetLink = '';
    if($('#confirmModal').length){

      // Eventlistener für alle Buttons mit der Klasse .open-modal-button
      $('.open-modal-button').on('click', function(e) {
          e.preventDefault(); // Standard-Link-Verhalten verhindern
          targetLink = $(this).attr('href'); // Speichere den Link des Buttons
          $('#confirmModal').foundation('open'); // Öffne das Modal
      });

      // Eventlistener für den Bestätigungs-Button im Modal
      $('#modal-confirm-button').on('click', function() {
          if (targetLink) {
            window.open(targetLink, '_blank'); // Öffne den Link in einem neuen Tab
          }
      });
   }
});
